<template>
  <div class="home">
    <div class="wrap">
      <base-header />
      <category-app :data="localData" />
      <banner :banner="data.banner" />
      <other-app :other-app="data.otherApp" />
      <banner :banner="data.banner" />
      <base-footer @download="switchDialogVisible(true)" />
    </div>
    <dialog-qrcode
      v-if="dialogVisible"
      :url="localUrl"
      @close="switchDialogVisible(false)" />
  </div>
</template>

<script>
import { onBeforeMount, ref } from '@vue/composition-api'
import useIndexInfo from '@/composables/useIndexInfo'
import BaseHeader from '@/components/Header'
import BaseFooter from '@/components/Footer'
import CategoryApp from '@/components/category-app/Index'
import Banner from '@/components/Banner'
import OtherApp from '@/components/other-app/Index'
import DialogQrcode from '@/components/DialogQrcode'

export default {
  name: 'Home',
  components: {
    BaseHeader,
    BaseFooter,
    CategoryApp,
    Banner,
    OtherApp,
    DialogQrcode
  },
  setup () {
    const dialogVisible = ref(false)

    const switchDialogVisible = (boolean) => {
      dialogVisible.value = boolean
    }

    let localData = null
    try {
      localData = window.__CONFIG__.DATA ? JSON.parse(window.__CONFIG__.DATA) : null
    } catch (err) {
      console.error('window.__CONFIG__.DATA JSON parse error:', err)
    }

    const data = ref({})

    onBeforeMount(async () => {
      data.value = await useIndexInfo(localData)
    })

    return {
      localUrl: window.location.origin,
      dialogVisible,
      switchDialogVisible,
      data,
      localData
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding: 0;
  margin: 0;
}

.wrap {
  min-width: 320px;
  max-width: 500px;
  margin: 0 auto;
  overflow: hidden;
  background: $bg;
  background-image: url("~@/assets/image/bg.svg");
  background-repeat: repeat-y;
  background-position: center center;
  background-size: cover;
}
</style>
